import { themeColor } from '@config/theme';
import { ChatTabType } from '@features/chat/types/types';
import { useWindowSize } from '@hooks/useWindowSize';
import { mdiArrowRight } from '@mdi/js';
import Icon from '@mdi/react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useChatStore } from '../store';

const ConfirmActionButton = () => {
	const { activeTab } = useChatStore();
	const { t } = useTranslation();
	const { width } = useWindowSize();

	const isMobile = width <= 576;
	const isChatsTab = activeTab === ChatTabType.Direct;

	const completeAction = () => {
		// if (isChatsTab) setCompleteModalOpen(true);
	};

	const isTealBg =
		(isChatsTab && !isMobile) || (!isChatsTab && !isMobile) || (!isChatsTab && isMobile);
	const isWhiteText = isChatsTab && !isMobile;

	const buttonStyles = {
		display: 'flex',
		padding: '8px 20px',
		alignItems: 'center',
		width: isMobile ? '100vw' : 'fit-content',
		borderRadius: isMobile ? '0px' : '12px',
		backgroundColor: isTealBg ? themeColor.teal : themeColor.contrastTextWhite,
		color: isWhiteText ? themeColor.contrastTextWhite : themeColor.teal,
	};

	const typographyStyles = {
		whiteSpace: 'nowrap',
		textTransform: 'uppercase',
		fontSize: isMobile ? (isChatsTab ? '16px' : '14px') : '12px',
		fontWeight: 700,
		lineHeight: isMobile ? 'normal' : '140%',
		color: isTealBg ? themeColor.contrastTextWhite : themeColor.teal,
	};

	return (
		<Button onClick={completeAction} sx={buttonStyles}>
			<Typography sx={typographyStyles}>
				{isChatsTab ? t('chats.completeConsultation') : t('chats.generateNewRequestTitle')}
			</Typography>
			{isChatsTab && isMobile && <Icon path={mdiArrowRight} size={1} />}
		</Button>
	);
};

export default ConfirmActionButton;
